export default __webpack_public_path__ + "static/media/explore8.d9bceb71.png";